module.exports = __webpack_public_path__ + "static/media/GastownStart.91534acf.jpg";